import axiosInstance from './axios';

export interface Notification {
  id: number;
  user_id: number;
  type: 'like' | 'reply' | 'message' | 'reminder' | 'comment';
  content: string;
  related_id: number | null;
  related_type: string | null;
  is_read: boolean;
  created_at: string;
}

export const notificationApi = {
  async getNotifications() {
    const response = await axiosInstance.get('/notifications');
    return response.data;
  },

  async getUnreadCount() {
    const response = await axiosInstance.get('/notifications/unread-count');
    return response.data;
  },

  async markAsRead(id: number) {
    const response = await axiosInstance.put(`/notifications/${id}/read`);
    return response.data;
  },

  async markAllAsRead() {
    const response = await axiosInstance.put('/notifications/read-all');
    return response.data;
  },

  async deleteNotification(id: number) {
    const response = await axiosInstance.delete(`/notifications/${id}`);
    return response.data;
  },
};

export default notificationApi;